export const featuresContent = `
## Powerful Algorithmic Trading Features

Take your trading to the next level with our suite of powerful tools designed for the Indian stock markets (NSE & BSE).

### 1. Strategy AI — Just describe it
Tell our AI what you want to trade — in plain English. It builds the full strategy with entry rules, exit conditions, and risk management. Ready to backtest in seconds.
* **Tags:** Natural Language | Auto Risk Management | Instant Strategy

![Strategy AI Interface](/images/StrategyAiPromptPage.png)

### 2. Build any algo strategy
Define entry and exit rules visually — no code required. Set stop loss, target profit, trailing stops, lot sizes, and indicators. Full control, zero complexity.
* **Tags:** Visual Rule Builder | 50+ Indicators | No Code

### 3. Backtest before you risk it
Validate your strategy against years of historical NSE data. Win rate, profit factor, max drawdown, equity curves — every metric you need before going live.
* **Tags:** Historical NSE Data | Equity Curve | Sharpe Ratio | Trade Log

![Backtesting Dashboard](/images/AiStrategyBacktestResultPage.png)

### 4. Go live. Zero emotion.
Connect Zerodha, Upstox, or Angel One in minutes. Your strategy runs 24/7 — executing orders automatically, with zero hesitation or second-guessing.
* **Tags:** Zerodha | Upstox | Angel One | Auto Execute

### 5. Practice first with Paper Trading
Not ready to risk real money? Run your strategy in paper trading mode — real market conditions, full P&L tracking, zero capital at risk.
* **Tags:** Real Market Data | Zero Risk | Full P&L Tracking
`;

export const aboutUsContent = `
## About StockAlgoTrader

**The Future of Algo Trading is Here.**

We are on a mission to democratize algorithmic trading for Indian markets (NSE & BSE). We believe advanced quantitative tools shouldn't be restricted to massive institutions—they should be accessible to every trader.

### Our Vision
To provide a seamless, all-in-one platform to build AI-powered strategies, backtest them against years of NSE historical data, and deploy them live automatically with zero emotion.

### How We Make It Happen
From sign-up to live algorithmic trading in minutes:
1. **Connect Your Broker:** Link Zerodha, Upstox, or Angel One with a single API key.
2. **Create a Strategy:** Use AI to describe your idea, or build manually with our visual editor.
3. **Backtest It:** Validate on historical NSE data and see exactly how your strategy performs.
4. **Go Live or Paper Trade:** Deploy with real capital — or practice risk-free first.
`;
